import { appRunUuidStorage } from '@nsftx/seven-client-retail-utils'

export const redirectToSsbt = () => {
  const url = new URL(import.meta.env.VITE_SSBT_URL)
  const appRunUuid = appRunUuidStorage.getAppRunUuid()

  if (appRunUuid) {
    url.searchParams.set('appRunUuid', appRunUuid)
  }

  window.location.href = url.toString()
}
